<template>
    <v-dialog width="800px" v-model="show">
        <v-card>
            <v-toolbar color="red" dark>
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <v-form id="createForm">
                <v-layout row>
                    <v-flex xs12 style="padding: 10px">
                        <form id="formProcess" class="dynamicForm">

                        </form>
                    </v-flex>
                </v-layout>
            </v-form>
            <div style="text-align: right">
                <v-btn v-if="this.$store.state.auth.accessLevel == 2" color="primary" dark @click="onSave" v-show="isEdit">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="orange darken-2" dark @click="onComplete" v-show="isEdit && taskId != null">
                    <v-icon dark left>check_circle</v-icon>
                    {{$t('lang.common.complete')}}
                </v-btn>
                <v-btn color="error" dark @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import formStyle from "../../../../public/plugin/form/form.css"
    import CTextbox from "../../../components/form/Textbox";
    import Validator from "../../../../public/js/validator";
    import FormGenerator from "../../../../public/plugin/form/form";
    import axios from "axios/index";
    import VueController from "../../../../public/js/controller";

    const v = Validator();

    export default {
        name: 'form-submit',
        components: {CTextbox, Validator},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'form'
            },
        },
        data: () => {
            return {
                values: {},
                show: false,
                isEdit:true,
                processDefinitionId: null,
                taskId: null,
                formCode:null,
                executionId:null
            }
        },
        created() {
            VueController.push(this);
            axios.get("plugin/form/form.json").then(data => {
                console.log("---config---");
                console.log(data);
                FormGenerator.inputConfig = data;
                //FormGenerator.createInputPanel();
            }, error => {
                alert("Can't get form config");
            });
        },
        destroyed() {
            VueController.removeComponentByEl(this);
        },
        methods: {
            onStart: function () {
                let formdata = FormGenerator.convertFormToJSON('formProcess');
                axios.post(process.env.VUE_APP_API_URL + "/task/start?processId=" + this.processDefinitionId, formdata).then(
                    response => {
                        alert("Process success");
                        this.show = false;
                        let tl = VueController.getComponentByComponentName("task-management");
                        tl.search();
                    }, error => {
                        alert("Process false: " + error);
                    }
                );
            },

            onComplete: function () {
                let formdata = FormGenerator.convertFormToJSON('formProcess');
                axios.post(process.env.VUE_APP_API_URL + "/task/complete?taskId=" + this.taskId, formdata).then(response=>{
                    alert("Process success");
                    this.show = false;
                    let tv = VueController.getComponentByComponentName("task-view");
                    tv.onCancel();
                },error => {
                    alert("Process false: " + jqXHR.responseText);
                });
            },

            onSave: function () {
                if(this.taskId == null) {
                    this.onStart();
                } else {
                    let formdata = FormGenerator.convertFormToJSON('formProcess');
                    axios.post(process.env.VUE_APP_API_URL + "/task/save?taskId=" + this.taskId, formdata).then(response=>{
                        alert("Process success");
                        this.show = false;
                        let tv = VueController.getComponentByComponentName("task-view");
                        tv.onCancel();
                    },error => {
                        alert("Process false: " + jqXHR.responseText);
                    });
                }
            },

            onShowForm: function (processDefinitionId) {
                this.show = true;
                this.isEdit = true;
                this.processDefinitionId = processDefinitionId;
                this.taskId = null;
                axios.post(process.env.VUE_APP_API_URL + "/task/getStartFormKey?processDefinitionId=" + processDefinitionId).then(
                    data => {
                        axios.post(process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + data).then(
                            form => {
                                FormGenerator.loadForm(FormGenerator.decodeHTML(form.formConfig), "formProcess");
                            },
                            error => {

                            }
                        );
                    },
                    error => {

                    }
                )
            },

            showTaskData: function (formCode, executionId, taskId) {
                this.isEdit = true;
                this.taskId = taskId;
                console.log(this.taskId);
                this.loadFormAndData(formCode,executionId);
            },

            viewTaskData: function (formCode, executionId, taskId) {
                this.isEdit = false;
                this.taskId = taskId;
                this.loadFormAndData(formCode,executionId);
            },

            loadFormAndData:function(formCode,executionId){
                this.show = true;
                this.formCode = formCode;
                this.executionId = executionId;
                axios.post(process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + formCode).then(
                    form => {
                        FormGenerator.loadForm(FormGenerator.decodeHTML(form.formConfig), "formProcess");
                        axios.post(process.env.VUE_APP_API_URL + "/task/taskWorkingVariables?taskId=" + executionId).then(
                            data=>{
                                FormGenerator.loadInputData(data);
                            },
                            error=>{

                            }
                        );
                    },
                    error => {

                    }
                );
            },

            onCancel: function () {
                this.show = false;
            }
        }
    }
</script>
